// extracted by mini-css-extract-plugin
export default {"main":"main__SearchMainView__t9ktT","searchPanel":"searchPanel__SearchMainView__t9ktT","searchFields":"searchFields__SearchMainView__t9ktT"};